import * as types from '../types'

export const pastReq = (data) => ({
  type: types.PAST_REQ,
  data
})

export const pastHandle = (data) => ({
  type: types.PAST_HANDLE,
  data
})



export const pastHandleTask = (data) => ({
  type: types.PAST_HANDLE_TASK,
  data
})